import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccountList from './account_list';
import AccountDetail from './account_detail';

class Account extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <AccountList/>;
    }else{
      if(params.id===undefined){
        view = <AccountDetail/>;
      }else{
        view = <AccountDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Account.contextTypes = {
  router: PropTypes.object
};

export default Account;
